<!--修改可见班级 Sag 2020-04-16-->
<template>
  <ya-dialog-box class="class-space-dialog" :visible.sync="dialogVisible" :width=width multi-layer :fast-close="false" :father-action="dialogBoxAction" top="10%">
    <p slot="title">{{title ? title : '提示'}}</p>
    <div class="its-container">
      <span class="its-title">可见班级：</span>
      <div class="its-class-items">
        <el-checkbox-group class="its-class-checkbox" v-model="checkList" @change="selectedClass">
          <el-checkbox class="its-class-item" :class="{'active':checkList.indexOf(item.classId)>=0}"  v-for="(item, i) in list" :key="i" :label="item.classId" :title="item.gradeName+item.className">{{item.gradeName+item.className}}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <template slot="btn">
      <button class="ts-base-btn ts-primary-btn plain padding" style="margin-right: 10px"
              @click="dialogAction('ok')" :disabled="checkList==0">确定</button>
      <button class="ts-base-btn ts-primary-btn padding" @click="dialogAction('close')">取消</button>
    </template>
  </ya-dialog-box>
</template>
<script>
import YaDialogBox from '../../../../components/YaDialogBox'
export default {
  name: 'ModifyClassDialog',
  components: {
    YaDialogBox
  },
  props: {
    width: {
      type: String,
      default: '410px'
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    items: { //已选的班级
      type: Array,
      default: function () {
        return [
          {
            id: 1,
            name: '高一1班'
          }
        ]
      }
    },
    type: {
      type: String,
      default: 'create'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    fatherAction: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      checkList:[],
      title: ''
    }
  },
  watch: {
    dialogVisible: function () {
      if(this.dialogVisible) {
        this.checkList = []
        this.items.forEach((item)=>{
          this.checkList.push(item.classId)
        })
        this.title = this.type=='create'?'设置可见班级':'修改可见班级'
      }
      console.log(this.checkList)
    }
  },
  methods: {
    dialogAction: function (type) {
      let result = []
      if (type == 'ok') {
      this.list.forEach((item)=>{
        if(this.checkList.indexOf(item.classId)>=0){
          result.push(item)
        }
      })
      }
      if(this.fatherAction) {
        this.fatherAction({type: type, checkList: this.checkList, items: result})
      }
    },
    dialogBoxAction: function (data) {
      if(this.fatherAction) {
        this.fatherAction(data)
      }
    },
    handleClose: function () {
      if(this.fatherAction) {
        this.fatherAction({type: 'close'})
      }
    },
    selectedClass: function () {
       console.log(this.checkList)
    }
  }
}
</script>

<style scoped>
.its-class-item >>>.el-checkbox__inner{
  /* display: none; */
  margin-right: 5px;
}
.its-container {
  margin-top: 10px;
}
.its-class-item{
  margin: 0;
  padding: 5px 10px;
  margin-right: 10px;
  color: #454545;
  background: white;
  margin-bottom: 10px;
  /* border: 1px solid #5591FE; */
  border-radius: 4px;
    /*width: 300px;*/
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    /*white-space: nowrap;*/
}
.its-class-checkbox .its-class-item.active{
  /* background: #5591fe; */
  color: #5591FE;
  border-radius: 4px;
}
.its-class-checkbox .its-class-item>>>.el-checkbox__label{
  padding: 0;
  color: #454545;
  font-size: 14px;
  line-height: 1;
    max-width: 270px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.its-class-checkbox .its-class-item.active>>>.el-checkbox__label{
  color: #5591FE;
}
.its-class-checkbox .its-class-item.active:hover{
  opacity: 0.8;
}
.its-title {
  vertical-align: top;
  margin-top: 3px;
  display: inline-block;
  font-size: 14px;
}
.its-class-items{
  display: inline-block;
  width: 300px;
}
</style>
